import { useEffect, useMemo, useState } from 'react';

const NuevoMetodoPago = ({ show, onClose, onSave }) => {
    const [nombre, setNombre] = useState('');
    const [descripcion, setDescripcion] = useState('');

    useEffect(() => {
        if (!show) return;

        const prevOverflow = document.body.style.overflow;
        const prevPaddingRight = document.body.style.paddingRight;

        document.body.classList.add('modal-open');
        document.body.style.overflow = 'hidden';
        document.body.style.paddingRight = prevPaddingRight;

        return () => {
            document.body.classList.remove('modal-open');
            document.body.style.overflow = prevOverflow;
            document.body.style.paddingRight = prevPaddingRight;
        };
    }, [show]);

    const disabled = useMemo(() => nombre.trim().length === 0, [nombre]);

    if (!show) return null;

    return (
        <>
            <div
                className="modal fade show"
                role="dialog"
                aria-modal="true"
                tabIndex="-1"
                style={{ display: 'block', zIndex: 1055 }}
            >
                <div className="modal-dialog modal-dialog-centered modal-lg" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">Agregar método de pago</h5>
                            <button type="button" className="btn-close" onClick={onClose} />
                        </div>

                        <div className="modal-body">
                            <div className="row g-3">
                                <div className="col-12">
                                    <div className="form-floating">
                                        <input
                                            type="text"
                                            className="form-control"
                                            id="nuevo-metodo-nombre"
                                            placeholder="Nombre"
                                            value={nombre}
                                            onChange={(e) => setNombre(e.target.value)}
                                        />
                                        <label htmlFor="nuevo-metodo-nombre">Nombre</label>
                                    </div>
                                </div>

                                <div className="col-12">
                                    <div className="form-floating">
                                        <textarea
                                            className="form-control"
                                            id="nuevo-metodo-descripcion"
                                            placeholder="Descripción"
                                            style={{ height: 120, resize: 'none' }}
                                            value={descripcion}
                                            onChange={(e) => setDescripcion(e.target.value)}
                                        />
                                        <label htmlFor="nuevo-metodo-descripcion">Descripción</label>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" onClick={onClose}>
                                Cancelar
                            </button>
                            <button
                                type="button"
                                className="btn btn-success"
                                disabled={disabled}
                                onClick={() => onSave({
                                    nombre: nombre.trim(),
                                    descripcion: descripcion.trim()
                                })}
                            >
                                Guardar
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <div
                className="modal-backdrop fade show"
                style={{ zIndex: 1050 }}
                onClick={onClose}
            />
        </>
    );
};

export default NuevoMetodoPago;
